import { isNumeric } from './is-numeric'
import { isString } from './is-string'

export const getEnumEntries = <T extends {}>(e: T): [string, string | number][] => {
  return Object.entries(e)
    .filter(([key]) => {
      return !isNumeric(key)
    })
    .filter((x): x is [string, string | number] => {
      const [, value] = x
      return isString(value) || isNumeric(value)
    })
}
